import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  headersSES,
  valoresExibidosOffCanvasSES as valoresExibidos,
  fieldObjectSes as fieldObject,
  SesTableRow,
} from './auxiliarSES';
import SubAbas from './subabas';
import { INITIAL_FORM_SES } from './utils/initialStates';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomInputMask from '../../../../components/CustomInputs/CustomInputMask';
import CustomModal from '../../../../components/CustomModal';
import CustomRow from '../../../../components/CustomRow';
import DetailsTable from '../../../../components/CustomTable/DetailsTable';
import { TableDetailsRow } from '../../../../components/CustomTable/types/table.type';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { getAllSes } from '../../../../services/ses/sesService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';

const SESIndex: React.FC = () => {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_Ses;
  const { cudSes } = useContext(UserContext);

  const navigate = useNavigate();

  //Dados do componente
  const theme = useTheme();
  const [data, setData] = useState<any[]>([]);
  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);

  const [showModal, setShowModal] = useState(false);

  const [formSes, setFormSes] = useState(INITIAL_FORM_SES(userID));

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllSes();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tableData = data.map((item) => ({
    id: item?.id ?? 'N/A',
    nome: item?.nome ?? 'N/A',
    ufSigla: item.municipioIbge?.ufSigla ?? 'N/A',
    cnes: item?.cnes ?? 'N/A',
    nomeEmpresarial: item?.nomeEmpresarial ?? 'N/A',
  }));

  //Dados do Offcanvas
  const offCanvasData: TableDetailsRow[] = data.map((item) => ({
    id: item?.id ?? 'N/A',
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    ses: <b>{item.nome}</b>,
    cnes: <b>{item.cnes}</b>,
    nomeEmpresarial: item.nomeEmpresarial,
    naturezaJuridica: item.naturezaJuridica.naturezaJuridica,
    dependencia: item.dependencia,
    regionalSaude: item.regionalSaude,
    tipoEstabelecimento: item.tipoEstabelecimento,
    subtipoEstabelecimento: item.subtipoEstabelecimento,
    gestao: item.gestao,
    separadorContato: '',
    telefone1: item.telefone1 ? item.telefone1 : '-',
    telefone2: item.telefone2 ? item.telefone2 : '-',
    email: item.email ? item.email : '-',
    site: item.site ? item.site : '-',
    separadorCEP: '',
    cep: item.cep,
    municipio: item.municipioIbge.municipio,
    uf: item.municipioIbge.uf,
    endereco: item.logradouro + ', ' + item.numeroImovel + ' - ' + item.bairro,
    complemento: item.complemento ? item.complemento : '-',
  }));

  const prepareDataForExport = (data: any, filteredData: any) => {
    const exportedData = [];
    const formatedData = data
      .filter((item: any) => filteredData.some((d: any) => d.id === item.id))
      .map((item: any) => ({
        id: item.id,
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,
        ses: item.nome,
        cnes: item.cnes,
        nomeEmpresarial: item.nomeEmpresarial,
        naturezaJuridica: item.naturezaJuridica.naturezaJuridica,
        dependencia: item.dependencia,
        regionalSaude: item.regionalSaude,
        tipoEstabelecimento: item.tipoEstabelecimento,
        subtipoEstabelecimento: item.subtipoEstabelecimento,
        gestao: item.gestao,
        telefone1: item.telefone1 ? item.telefone1 : '-',
        telefone2: item.telefone2 ? item.telefone2 : '-',
        email: item.email ? item.email : '-',
        site: item.site ? item.site : '-',
        cep: item.cep,
        municipio: item.municipioIbge.municipio,
        uf: item.municipioIbge.uf,
        logradouro: item.logradouro ? item.logradouro : '-',
        numeroImovel: item.numeroImovel ? item.numeroImovel : '-',
        bairro: item.bairro ? item.bairro : '-',
        complemento: item.complemento ? item.complemento : '-',
        observacoes: item.observacoes,
      }));

    exportedData.push(formatedData);

    return exportedData;
  };

  //Handlers
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setFormSes((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTableRowClick = (row: SesTableRow) => {
    if (row?.id) {
      navigate(`ficha/${row.id}/dadosgerais`);
    }
  };

  const handleOpenDetails = (row: SesTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `/ficha/${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais', { state: { formSes } });
  };

  const handleClearModal = () => {
    setFormSes(INITIAL_FORM_SES(userID));
  };

  const handleShowModal = () => {
    handleClearModal();
    setShowModal((show) => !show);
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersSES}
          data={tableData}
          displayValues={valoresExibidos}
          offcanvasTitle="Estabelecimento de Saúde"
          widthOffcanvas="60%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={20}
          showPagination
          showOpenButton
          filterable
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidos}
            />
          )}
        </CustomTableOffcanvas>

        {/* Modal de inserção */}
        <CustomModal
          icon="medical_information"
          title="Novo Estabelecimento de Saúde"
          open={showModal}
          onClose={handleShowModal}
          width="25%"
        >
          <CustomRow className="mb-4" style={{ alignItems: 'flex-end' }}>
            <CustomCol width="75%" style={{ display: 'flex', gap: '8px' }}>
              <CustomInputMask
                mask="9999999"
                name="cnes"
                title="Código CNES"
                value={formSes.cnes}
                onChange={handleChange}
                required
              />

              <CustomButton
                label="Inserir"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleClickInserir}
                style={{
                  marginTop: '28px',
                  marginLeft: '20px',
                  // padding: '0px 24px',
                }}
              />
            </CustomCol>
          </CustomRow>
        </CustomModal>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // onClickDownload={() =>
          //   ExportToExcel(
          //     prepareDataForExport(data, tableData),
          //     valoresExibidos,
          //     fieldObject,
          //     'ses.xlsx',
          //     userID,
          //     'DAF',
          //     entity,
          //   )
          // }
          inserir
          onClickInserir={handleClickInserir}
          inserirDisabled={!cudSes}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default SESIndex;
